import { type Consumer, createConsumer } from '@rails/actioncable';
import { createContext } from 'react';

export const consumer = createConsumer(import.meta.env.VITE_WS_URL);

export const ActionCableContext = createContext<Consumer>(consumer);
